import Pet from '@spike/pet-model';
import clsx from 'clsx';
import { PetTag } from 'components/UI/V3/PetTag/PetTag';
import styles from 'components/UI/V3/PetTag/Tabs/PetTagTabs.module.scss';
import React from 'react';

interface PetTagTabsProps {
    value: Pet;
    pets: Array<Pet>;
    onChange: (value: Pet) => void;
    className?: string;
}

export const PetTagTabs: React.FC<PetTagTabsProps> = ({ value, pets, onChange, className }) => {
    return (
        <div className={clsx(styles.root, className)}>
            {pets.map(pet => (
                <PetTag
                    key={pet.id}
                    pet={pet}
                    active={pet.id === value.id}
                    onClick={() => onChange(pet)}
                />
            ))}
        </div>
    );
};
